/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Swap_Today_ToastInputs */

const en_us2_swap_today_toast = /** @type {(inputs: Swap_Today_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} for today only`)
};

const pt_br2_swap_today_toast = /** @type {(inputs: Swap_Today_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} só hoje`)
};

const es_419_swap_today_toast = /** @type {(inputs: Swap_Today_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} solo por hoy`)
};

const pt_pt2_swap_today_toast = /** @type {(inputs: Swap_Today_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} só hoje`)
};

const fr_fr2_swap_today_toast = /** @type {(inputs: Swap_Today_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} pour aujourd'hui seulement`)
};

const de_de2_swap_today_toast = /** @type {(inputs: Swap_Today_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nur für heute`)
};

const it_it2_swap_today_toast = /** @type {(inputs: Swap_Today_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} solo per oggi`)
};

/**
* | output |
* | --- |
* | "{name} for today only" |
*
* @param {Swap_Today_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_today_toast = /** @type {((inputs: Swap_Today_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Today_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_today_toast(inputs)
	if (locale === "es-419") return es_419_swap_today_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_today_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_today_toast(inputs)
	if (locale === "de-DE") return de_de2_swap_today_toast(inputs)
	if (locale === "it-IT") return it_it2_swap_today_toast(inputs)
	return en_us2_swap_today_toast(inputs)
});
export { swap_today_toast as "swap.today_toast" }